export const ONBOARDING_PRESENCE_PAGE_STATE_KEYS = {
	PRESENCE_AVATAR_GROUP_DB_SPOTLIGHT_SEEN: 'database:databasePresenceAvatarGroupSpotlightSeen',
} as const;

export const PresencePageOnboardingKeys = [
	...Object.values(ONBOARDING_PRESENCE_PAGE_STATE_KEYS),
] as const;
